export const PROJECT_FORM_STEPS = [
  { key: 'basic', label: 'Basic Details' },
  { key: 'sanction', label: 'Sanction & Quotation' },
  { key: 'type', label: 'Type of Work' },
  { key: 'poc', label: 'POC' },
  { key: 'accounting', label: 'Accounting' },
  { key: 'quotation', label: 'Quotation' },
  { key: 'files', label: 'File Section' },
  { key: 'status', label: 'Job Status', disabled: true },
];

export const BOOLEAN_OPTIONS = [
  { label: 'No', value: false, key: 'NO' },
  { label: 'Yes', value: true, key: 'YES' },
];
